import { Component} from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { StoreInfoPageFull } from '../store-info/store-info.full';
import { StoreLocatorData } from '../../providers/store-locator-data';
import { NavController, Events, LoadingController, ActionSheetController, AlertController, App } from 'ionic-angular';
import { Utils } from '../../../../providers/utils';
import { PageRef } from '../../../../core/page-ref';

@Component({
  selector: 'page-store-locator-full',
  templateUrl: 'store-locator.full.html'
})
export class StoreLocatorPageFull extends PageBaseFull{
	public lstStores: any;
	public loader: any;
	public filteredItems: any;
	public pagedFilteredItems: any = []; 
	public pageSize: Number = 15;
	public hasMore = true;
	public currentStore: any = {};
	public centerPointsMap: any = {lat : 32.808053, lng: -96.771812};
	public mapZoom: number = 5;
	// google map settings
	private gMapRadius: number;
	private gMapCenterPointsDefault: any;
	private gMapZoom: number;
	public pageRef: PageRef;

    constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public storeLocatorData: StoreLocatorData,	
		public actionsheetController: ActionSheetController,
        public loadingCtrl: LoadingController,
        public alertCtroller: AlertController,
        public app: App,

	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
		if(!this.settings.gMapCenterPointsDefault ||  !this.settings.gMapCenterPointsDefault.lat || !this.settings.gMapCenterPointsDefault.lng){
            this.settings.getData().subscribe(sets=>{
               this.gMapCenterPointsDefault = sets.gMapCenterPointsDefault;
			   this.centerPointsMap = sets.gMapCenterPointsDefault;
			   this.gMapRadius = sets.gMapRadius;
			   this.gMapZoom = sets.gMapZoom;
			   this.mapZoom = sets.gMapZoom +  5;
            });
        }
        else{
            this.gMapCenterPointsDefault = this.settings.gMapCenterPointsDefault;
			this.centerPointsMap = this.settings.gMapCenterPointsDefault;
			this.gMapRadius = this.settings.gMapRadius;
			this.gMapZoom = this.settings.gMapZoom;
			this.mapZoom = this.settings.gMapZoom;
        }
	}
	// modeMap: boolean = true;
	// searchBar: boolean = false;
  	// zoom: number = 5;
	// lat: number = 34.2057115;
	// lng: number = -101.7087197;
	// public loadPage(){
	// 	let self = this;
	// 	for (let i=0; i< this.pageSize; i++){
    // 		if(self.pagedFilteredItems.length >= self.filteredItems.length){
    // 			self.hasMore = false;
    // 			return;
    // 		}
	// 		this.pagedFilteredItems.push(self.filteredItems[self.pagedFilteredItems.length]);
	// 	}
	// }

	// public loadMoreItems(infiniteScroll) {
	//     let self = this;
	//     setTimeout(() => {
	//     	self.loadPage();
	// 		infiniteScroll.complete();
	//     }, 500);
	
	// }

	// public loadData(){
	// 	let self = this;
	// 	self.loader = this.loadingCtrl.create();
	// 	self.loader.present();
	// 	self.storeLocatorData.getAllStores().subscribe((stores)=>{
	// 		if(stores){
	// 			self.lstStores = Utils.toArray(stores).reverse();
	// 			console.log(self.lstStores);
	// 			self.filteredItems = self.lstStores;
	// 			this.pagedFilteredItems = [];
	// 			self.loadPage();
	// 		}
	// 		self.loader.dismiss();
	// 	});
	// }

	// public StoreLocatorData(event) {
	//     let self = this;
	//     self.filteredItems = self.lstStores;
	//     var keyword = event.target.value;

	//     if (keyword && keyword.trim() != '') {
	//         self.filteredItems =  _.filter(self.lstStores, function(store:any){
	//          	return (store.value.zipCode.toLowerCase().indexOf(keyword.toLowerCase()) > -1) || 
	//          		(store.value.storeName.toLowerCase().indexOf(keyword.toLowerCase()) > -1) ||
	// 	         	(store.value.city && store.value.city.toLowerCase().indexOf(keyword.toLowerCase()) > -1);
	//         });
	//         self.pagedFilteredItems = [];
	//         self.loadPage();   
	//     }
    // }

	public loadPage(){
		let self = this;
		for (let i=0; i< this.pageSize; i++){
    		if(self.pagedFilteredItems.length >= self.filteredItems.length){
    			self.hasMore = false;
    			return;
    		}
			this.pagedFilteredItems.push(self.filteredItems[self.pagedFilteredItems.length]);
		}
	}

	public loadMoreItems(infiniteScroll) {
	    let self = this;
	    setTimeout(() => {
	    	self.loadPage();
			infiniteScroll.complete();
	    }, 500);
	
	}

	public initPage(){
		let self = this;
		self.loader = this.loadingCtrl.create();
		self.loader.present();
		  self.storeLocatorData.searchStore('','distance').subscribe((stores)=>{
			if(!stores){
				return;
			}
			if(stores.length > 0){
				var defaultStore = stores[0];
				self.centerPointsMap.lat = defaultStore.latitude;
				self.centerPointsMap.lng = defaultStore.longitude;
				self.mapZoom = self.gMapZoom;
			}
			self.loadStoresData(stores);
		});
	}

	public loadStoresData(data){
		let self = this;
		self.lstStores = Utils.toArray(data).reverse();
		self.lstStores.map(store =>{

			if(store && store.value.services){
				store.value.services = Utils.toArray(store.value.services).reverse();
				store.value.servicesTxt = store.value.services.slice(0,3).map(service => {
					return service.value.name;
				}).join(', ');
				
				if(store.value.services.length >=3){
					store.value.servicesTxt = store.value.servicesTxt + ', ...';
				}
			}
		})
		self.filteredItems = self.lstStores;
		this.pagedFilteredItems = [];
		self.loadPage();
		self.loader.dismiss();
	}

	searchStores(keyword){
		let self = this;
		var keyword = keyword.trim();
		self.loader = this.loadingCtrl.create();
		self.loader.present();
	    self.storeLocatorData.searchStore(keyword).subscribe((stores)=>{
			if(!stores){
				return;
			}
			if(stores.length > 0){
				var defaultStore = stores[0];
				self.centerPointsMap.lat = defaultStore.latitude;
				self.centerPointsMap.lng = defaultStore.longitude;
				self.mapZoom = self.gMapZoom;
			}
			self.loadStoresData(stores);
		});
	}

	nearBy(){
		let self = this;
		self.loader = this.loadingCtrl.create();
		self.loader.present();
		self.storeLocatorData.getCurrentPosition().subscribe((res:any) => {
			console.log(res);
			var latlgn = '';
			if(res){
				if(res.latitude && res.longitude){
					latlgn = res.latitude &&  res.longitude ? res.latitude+ ',' + res.longitude : '';
					self.centerPointsMap.lat = res.latitude;
					self.centerPointsMap.lng = res.longitude;
					self.mapZoom = self.gMapZoom + 3;
				}
			}
			self.storeLocatorData.getStoreByCoords(latlgn).subscribe((stores)=>{
				if(stores){
					self.loadStoresData(stores);
				}
			});
		},(error:any) => {
			self.loader.dismiss();
			if(error){
				self.alertCtroller.create({
					title: 'Store Locator',
					message : error.message
				});
			}
			else {
				self.alertCtroller.create({
					title: 'Store Locator',
					message : 'Please enable location service.'
				});
			}
		});
	}

	ngAfterViewInit() {
	}

	ionViewDidEnter() {
		this.appendFooterScripts('assets-full/base/js/scripts/pages/isotope-grid.js');
		//this.appendFooterScripts('https://maps.google.com/maps/api/js?key=AIzaSyA-lOBNTsKxV8MKKMLdMU_m6aIbX0h6wm8');
		//this.appendFooterScripts('assets-full/theme/gmaps/gmaps.js');
		//this.appendFooterScripts('assets-full/base/js/scripts/pages/contact.js');
		this.app.setTitle('Store Locator');
		console.log(this.currentStore);
		this.initPage();
	}
	
	viewStore(id){
		console.log(id);
		this.nav.push(StoreInfoPageFull, {id: id});
	}

	public viewWeeklyAd(store){
		this.storeLocatorData.setCurrentStore(store);
		this.nav.setRoot(this.pageRef.get('weekly-ad'));
	}
}



// WEBPACK FOOTER //
// ./src/modules/store-locator/pages/store-locator/store-locator.full.ts